import { render } from "./WavFooter.vue?vue&type=template&id=28ee4275"
import script from "./WavFooter.vue?vue&type=script&lang=js"
export * from "./WavFooter.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Website/Website/front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__